var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareKnowledge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 11.4062C4.59207 8.88776 8.00708 8.76917 10.4375 11.4062M8.88556 4.70312C8.88556 6.12698 7.72965 7.28125 6.30377 7.28125C4.87788 7.28125 3.72197 6.12698 3.72197 4.70312C3.72197 3.27927 4.87788 2.125 6.30377 2.125C7.72965 2.125 8.88556 3.27927 8.88556 4.70312Z",
    stroke: "#F97316",
    strokeWidth: 1.6875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 22.75C16.9671 20.2315 20.382 20.1129 22.8125 22.75M21.2606 16.0469C21.2606 17.4707 20.1046 18.625 18.6787 18.625C17.2529 18.625 16.097 17.4707 16.097 16.0469C16.097 14.623 17.2529 13.4688 18.6787 13.4688C20.1046 13.4688 21.2606 14.623 21.2606 16.0469Z",
    stroke: "#F97316",
    strokeWidth: 1.6875,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21875 14.5C3.21875 18.4909 6.44656 21.7188 10.4375 21.7188L9.40625 19.6562",
    stroke: "#F97316",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5938 3.15625H21.7812M15.5938 6.25H21.7812M15.5938 9.34375H19.2031",
    stroke: "#F97316",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareKnowledge);
export default __webpack_public_path__ + "static/media/share-knowledge.86d5e732392b154722dcf953128c1b2b.svg";
export { ForwardRef as ReactComponent };